module.exports = __webpack_public_path__ + "img/shipping.6c5da366.svg";